/** skulls.png overlay on opponent general portrait when Plague of Water turned to Blood (220) is requested. */
export const PLAGUE_220_SKULLS_IMAGE_SRC = '/images/skulls.png';

/** Visible duration on the opponent general portrait (ms). */
export const PLAGUE_220_SKULLS_PORTRAIT_DURATION_MS = 2000;

/** `data-zone` on opponent general portrait elements (OpponentHUD / mobile). */
export const PLAGUE_220_OPPONENT_GENERAL_DATA_ZONE = 'opponent_general';
